import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { forkJoin, fromEvent, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { QrveyService } from '../../../../../core/lists/_services/qrvey.service';
import { LayoutUtilsService } from '../../../../../core/_base/crud';
import { SubheaderService } from '../../../../../core/_base/layout';
import { distinctUntilChanged, map, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../../../environments/environment';
import { AuthService } from '../../../../../core/auth';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'kt-qrvey-deploye-pages-list',
  templateUrl: './qrvey-deploye-pages-list.component.html',
  styleUrls: ['./qrvey-deploye-pages-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QrveyDeployePageslistComponent implements OnInit, OnDestroy {
  dataSource = [];
  displayedColumns = ['pageId', 'userEmail', 'action'];
  private subscriptions: Subscription[] = [];
  private appId = null;
  private qrveyAppId = null;
  @ViewChild('search', { static: true }) searchInput: ElementRef;
  allResult = [];
  loading = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<QrveyDeployePageslistComponent>,
    public dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private layoutUtilsService: LayoutUtilsService,
    private qrveyService: QrveyService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    private authService: AuthService,
    public subheaderService: SubheaderService,
  ) {
    this.appId = this.data.appId;
    this.qrveyAppId = this.data.qrveyAppId;
    this.loadPageList();
  }

  ngOnInit() {
    fromEvent(this.searchInput.nativeElement, 'keyup')
      .pipe(
        distinctUntilChanged(),
        tap(() => {
          this.dataSource = this.allResult.filter((val) =>
            val.search.includes(this.searchInput.nativeElement.value.toLowerCase()),
          );
          this.cdr.detectChanges();
        }),
      )
      .subscribe();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  loadPageList() {
    this.loading = true;
    forkJoin({
      qrveyPages: this.qrveyService.getAllPagesFromQRVEY(
        this.qrveyAppId,
        localStorage.getItem(environment.qvUserId),
      ),
      knostosPages: this.authService.getQRVEYApps(),
    })
      .pipe(
        map((response) => {
          const allPagesQrvey = response.qrveyPages.Items as Array<any>;
          const knostos = response.knostosPages.data as Array<any>;

          let allPagesKnostos = [];
          knostos.filter((app) => {
            allPagesKnostos = allPagesKnostos.concat(app.pages);
          });

          const resFinal = allPagesQrvey
            .filter((e) => e.published)
            .map((qpage) => {
              const kpage = allPagesKnostos.find((p) => qpage.pageid === p.qrvey_page_id);
              qpage.onKnostos = false;
              const name = '' + qpage.name + qpage.pageid;
              qpage.search = name.toLowerCase();
              if (kpage) {
                qpage.onKnostos = true;
              }
              return qpage;
            });
          return resFinal;
        }),
      )
      .subscribe((data) => {
        if (!data) {
          return;
        }
        this.allResult = data.sort((a, b) => a.status - b.status);
        this.dataSource = this.allResult;
        this.loading = false;
        this.cdr.detectChanges();
      });
  }

  unblock(page) {
    const body = {
      qrvey_page_id: page.pageid,
      name: page.name,
    };
    this.qrveyService.deployPage(body, this.appId).subscribe(() => {
      this.loadPageList();
    });
  }
}
